export const galleryImages = [
  { id: 0, image: '/assets/gallery/img0.webp' },
  { id: 1, image: '/assets/gallery/img1.webp' },
  { id: 2, image: '/assets/gallery/img2.webp' },
  { id: 3, image: '/assets/gallery/img3.webp' },
  { id: 4, image: '/assets/gallery/img4.webp' },
  { id: 5, image: '/assets/gallery/img5.webp' },
  { id: 6, image: '/assets/gallery/img6.webp' },
  { id: 7, image: '/assets/gallery/img7.webp' },
  { id: 8, image: '/assets/gallery/img8.webp' },
  { id: 9, image: '/assets/gallery/img9.webp' },
  { id: 10, image: '/assets/gallery/img10.webp' },
  { id: 11, image: '/assets/gallery/img11.webp' },
  { id: 12, image: '/assets/gallery/img12.webp' },
  { id: 13, image: '/assets/gallery/img13.webp' },
  { id: 14, image: '/assets/gallery/img14.webp' },
  { id: 15, image: '/assets/gallery/img15.webp' },
];
